import axiosServices from "../utils/axios";

export const fetchTags = async () => {
  const response = await axiosServices.get(`/tags`);
  return response.data.data;
};

export const updateTagsList = async (tag_id: string,   data: {
    [key: string]: any;
    tag_id: string;
  }) => {
  const requestData = { ...data };
  const response = await axiosServices.put(`/tags/${tag_id}`, requestData);
  return response?.data?.data;
};

export const deleteTagssData = async (id: string) => {
  const response = await axiosServices.delete(`/tags/${id}`);
  return { success: response?.data?.success, id };
};

export const addTagsData = async (data: { [key: string]: any }) => {
  const response = await axiosServices.post(`/tags`, data);
  return response?.data?.data;
};
